import { cn } from 'lib/utils';
import * as React from 'react';

/** Figma: "Textarea - Nova". Diverges on purpose like `Input`: 16px radius and the same horizontal padding. */
function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'border-input placeholder:text-subtle-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-ring-destructive/20 aria-invalid:border-ring-destructive flex field-sizing-content min-h-20 w-full resize-none rounded-lg border bg-card px-3 py-2.5 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
